<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <section v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <div class="breads container">
        <bread></bread>
      </div>
      <div class="container">
        <SeqTopSearch
          :orderNos.sync="orderNos"
          :tabList="tabList"
          :useInfo="useInfo"
          lastBtnText="开始分析"
          @upload="handleUploadFile"
          @start="handleStart"
          @clear="clearTableData"
        />
        <div v-if="reqId" class="success-box mb50">
          <i class="el-icon-success"></i>
          <div class="success-title">分析完成</div>
          <div>
            点击 <el-button type="text" @click="handleDownload()" class="download-btn">下载报告</el-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread";
import SeqTopSearch from "./component/SeqTopSearch";
import { showLoading, hideLoading } from "@/views/user/children/loading";
import {
  ab1ReportByCode,
  ab1ReportDownload,
  ab1ReportByFile,
} from "@/services/api.tools";
export default {
  components: { bread, SeqTopSearch },
  data() {
    return {
      orderNos: "",
      tableData: [],
      uploadFilePath: "",
      tabList: [
        {
          label: "订单号维度",
          name: "order",
        },
        {
          label: "ab1峰图维度",
          name: "ab1",
        },
      ],
      useInfo: {
        list: [
          "使用说明：",
          "1、数据格式：需处理的数据为.ab1峰图或峰图压缩包（只支持.zip）或多个ab1。",
          "2、ab1命名：即“样品_引物_订单号_孔号.ab1”。注：“_”为一条下划线。",
          "3、使用详情，请点击：文档指南或视频指南。",
          "4、如有异常，请发送具体问题到对应邮箱：Cloud_Tool_Problem@tsingke.com.cn",
        ],
      },
      buttonList: [
        {
          label: "下载报告",
          value: "report",
        },
      ],
      prefixName: "峰图报告",
      reqId: "", //下载唯一标识
    };
  },
  mounted() {
    this.orderNos = this.$route.params.nos
      ? this.$route.params.nos.join(";")
      : "";
    console.log(this.orderNos);
  },
  methods: {
    async handleUploadFile(file, callback) {
      showLoading({ text: "正在分析中，请耐心等待！" });
      try {
        let res = await ab1ReportByFile(file);
        if (res) {
          this.reqId = res.data.reqId;
          this.$message.success("分析完成");
          callback(true);
        }
      } finally {
        hideLoading();
      }
    },
    async handleStart() {
      this.tableData = [];
      showLoading({ text: "正在分析中，请耐心等待！" });
      try {
        let res = await ab1ReportByCode({ orderCode: this.orderNos });
        if (res.status === 200) {
          this.reqId = res.data.reqId;
          this.$message.success("分析完成");
        }
      } finally {
        hideLoading();
      }
    },
    clearTableData() {
      this.reqId = "";
    },
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    // 下载按钮
    async handleDownload() {
      showLoading({ text: "文件下载中，请耐心等待！" });
      try {
        let res = await ab1ReportDownload(this.reqId);
        console.log(res);
        if (res.data) {
          this.baseMethods.downloadFile(
            res.data,
            `${this.prefixName}${this.baseMethods.dateToString()}`,
            "pdf"
          );
        } else {
          this.$message.error(res.title);
        }
      } catch (err) {
        const fileReader = new FileReader();
        fileReader.readAsText(err, "utf-8");
        fileReader.onload = () => {
          const result = JSON.parse(fileReader.result);
          console.log("catch", result);
          this.$message.error(result.title);
        };
      } finally {
        hideLoading();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.breads {
  overflow: auto;
  line-height: 48px;
}
.table-btn {
  padding: 0px;
}
</style>


// WEBPACK FOOTER //
// src/views/tools/seqExportReport.vue